import { trackEvent } from "@/services/posthog.service";

export const EVENT_ACTIVE_VIEW_CREATED = "MUTATION:ACTIVE_VIEW:CREATED";
export const EVENT_ACTIVE_VIEW_UPDATED = "MUTATION:ACTIVE_VIEW:UPDATED";

export const EVENT_STORED_VIEW_CREATED = "MUTATION:STORED_VIEW:CREATED";
export const EVENT_STORED_VIEW_UPDATED = "MUTATION:STORED_VIEW:UPDATED";
export const EVENT_STORED_VIEW_DELETED = "MUTATION:STORED_VIEW:DELETED";

type ActiveViewEventType = typeof EVENT_ACTIVE_VIEW_CREATED | typeof EVENT_ACTIVE_VIEW_UPDATED;
type StoredViewEventType =
  | typeof EVENT_STORED_VIEW_CREATED
  | typeof EVENT_STORED_VIEW_UPDATED
  | typeof EVENT_STORED_VIEW_DELETED;

export const trackActiveViewEvent = (event: ActiveViewEventType, payload: unknown) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  trackEvent(event, payload as any);
};

export const trackStoredViewEvent = (event: StoredViewEventType, payload: unknown) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  trackEvent(event, payload as any);
};
